<template>
  <v-container text-xs-center>
    <v-layout
      row
      wrap
    >
      <v-container
        style="max-height: 25vh; min-width: 1000px !important"
        class="scrollDesign"
      >
        <v-layout
          row
          wrap
        >
          <v-flex
            ma-1
            xs12
            class="expandableContainer"
          >
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="extras"
              :loading="loading"
              hide-actions
              ref="table-workshop"
              item-key="id"
              select-all
              no-data-text="No tiene talleres"
            >
              <template v-slot:headers="props">
                <tr>
                  <th
                    style="width: 500px; max-width: 500px; min-width: 500px;"
                    v-for="header in props.headers"
                    :key="header.text"
                  >
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td style="width: 500px; max-width: 500px; min-width: 500px;">
                  {{ props.item.course.name }}
                </td>
                <td style="width: 500px; max-width: 500px; min-width: 500px;">
                  {{ getStatusCourse(props.item) }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <!--v-on:desition="desitionDelete"-->
        <loading
          v-model="working.wLoading"
          text="Trabajando"
        />
        <success
          v-model="toast.success"
          text="Operación Exitosa"
        />
        <error
          v-model="toast.failed"
          text="Ups ocurrió un error"
        />
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import confirm from "../../Dialogs/Confirm";
import TutorModal from "../../Modals/TutorModal";
import LinkParent from "../../Modals/LinkParentModal";
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import axios from "axios";
export default {
  components: {
    confirm,
    TutorModal,
    LinkParent,
    loading,
    success,
    error
  },
  props: ["extras", "studentName", "studentId", "permits"],
  data: () => ({
    headers: [
      {
        text: "Nombre del curso",
        align: "center",
      },
      {
        text: "Estatus",
        align: "center",
      },
    ],
    selected: [],
    select: {
      parent: null
    },
    working: {
      wLoading: false
    },
    loading: false,
    avatarSize: "30px",
    tile: false,
    modals: {
      title: "",
      parent: false,
      import: false,
      value: false,
      LinkV: false
    },
    confirm: {
      value: false,
      title: "",
      description: "",
      show: false
    },
    buttonFab: {
      fab: false,
      hidden: false
    },
    gotImages: 0,
    toast: {
      success: false,
      failed: false
    },
    imgKey: 0
  }),
  created() {},
  mounted() {},
  methods: {
    getStatusCourse(item){
      switch (item.status) {
        case "E":
          return "Inscrito"
        case "C":
          return "Completado"
        case "D":
          return "Dado de baja"
      }
    }
  }
};
</script>
<style>
.no-padding {
  padding-left: 10%;
}
.position-no {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: -1;
}

.expandableContainer {
  border-style: solid;
  border-color: #e6e6e6;
  border-radius: 15px;
  border-width: 2px;
}
</style>
<style scoped>
th,
td {
  width: 550px;
  max-width: 550px;
  min-width: 550px;
}
</style>

